<script>
import { parse } from 'date-fns';
import service from '@/service';
import Loading from 'vue-loading-overlay';
import * as Ladda from 'ladda';
import settings from '@/settings.js';

export default {
	components: {
		Loading
	},
	methods: {
		showModal: function (id, prodajalec, kupec, ogrodje, vozilo, stRacuna, datumRacuna, skupniZnesek, prodajnaCena, nakazila, povracilaSkupaj, starost, datumProdajalecPotrdil, datumSekretarPotrdil, datumModeratorPotrdil, datumRacunovodjaPotrdil, podaljsanoJamstvoZnesek, myrZnesek) {
			this.showError(null);
			this.isLoading = false;
			this.item_id = id;
			this.prodajalec = prodajalec;
			this.kupec = kupec;
			this.ogrodje = ogrodje;
			this.vozilo = vozilo;
			this.st_racuna = stRacuna;
			this.datum_racuna = datumRacuna;
			this.znesek_racuna = skupniZnesek;
			this.prodajna_cena = prodajnaCena;
			this.nakazila = nakazila;
			this.povracila_skupaj = povracilaSkupaj;
			this.starost = starost;
			this.datumProdajalecPotrdil = datumProdajalecPotrdil;
			this.datumSekretarPotrdil = datumSekretarPotrdil;
			this.datumModeratorPotrdil = datumModeratorPotrdil;
			this.datumRacunovodjaPotrdil = datumRacunovodjaPotrdil;
			this.podaljsanoJamstvoZnesek = podaljsanoJamstvoZnesek;
			this.myrZnesek = myrZnesek;
			this.$refs.modal.show();
		},
		click_okModal: function (evt) {
			evt.preventDefault();
			this.showError(null);
			this.isLoading = true;
			service.saveMapaUserPotrdil(this.item_id)
				.then(response => {
					this.isLoading = false;
					if (response['message'] === 'success') {
						this.action_confirmed = true;
						this.$refs.modal.hide();
						this.$emit('userpotrdil-success', (response['datum'] ? parse(response['datum']['date'], settings.dbDtFormat) : null), response['user_id'], response['user_role'], response['akcija']);
					} else if (response['message'] === 'roleAlreadyConfirmed') {
						this.showError('Trenutna vloga je že potrdila!');
					} else if (response['message'] === 'moderatorNotYetConfirmed') {
						this.showError('Najprej mora potrditi moderator!');
					} else if (response['message'] === 'allConfirmed') {
						this.showError('Vse vloge so že potrdile!');
					} else {
						this.showError('Neveljaven odziv strežnika!');
						console.error('Neveljaven response message: ' + response['message']);
					}
				})
				.catch(error => {
					this.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
							this.showError('Napaka pri validaciji na strežniku!');
							console.error(error.response.data.message + ': ', error.response.data.errors);
						} else if (error.response.data.message === settings.errorMessages.notSavedError) {
							this.showError('Napaka pri shranjevanju!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.unknownRole) {
							this.showError('Neznana vloga uporabnika!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.PDOException) {
							this.showError('Napaka na strežniku!');
							console.error(error.response.data.message, 'details in .ex');
						} else {
							this.showError('Neznana napaka na strežniku!');
							console.error(error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.log('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		click_cancelModal: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
		},
		onHiddenModal: function (evt) {
			if (!this.action_confirmed) {
				this.$emit('userpotrdil-canceled');
			}
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		click_updateData: function (evt) {
			if (this.item_id) {
				let loader = Ladda.create(this.$refs.aUpdate);
				loader.start();
				service.getMFilesInfo(this.item_id)
					.then(response => {
						loader.stop();
						if (!response.item) {
							return;
						}
						if (response.item.id !== this.item_id) {
							return;
						}
						this.st_racuna = response.item.st_racuna;
						this.datum_racuna = parse(response.item.datum_racuna, settings.dbDtFormat);
						this.znesek_racuna = Number(response.item.skupni_znesek);
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
						loader.stop();
					});
			}
		}
	},
	data: function () {
		return {
			isLoading: false,
			item_id: null,
			prodajalec: '',
			kupec: '',
			ogrodje: '',
			vozilo: '',
			st_racuna: '',
			datum_racuna: '',
			znesek_racuna: 0,
			prodajna_cena: 0,
			nakazila: [],
			povracila_skupaj: 0,
			starost: 0,
			datumProdajalecPotrdil: null,
			datumSekretarPotrdil: null,
			datumModeratorPotrdil: null,
			datumRacunovodjaPotrdil: null,
			podaljsanoJamstvoZnesek: null,
			myrZnesek: null,
			gumbPotrdiTitle: '',
			message: {
				type: null,
				text: null
			},
			action_confirmed: false,
			ACTION_TYPE_ERROR: 'ERROR'
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		isRoleProdajalec () {
			return settings.isProdajalec(this.user.role);
		},
		isRoleSekretar () {
			return settings.isSekretar(this.user.role);
		},
		isRoleRacunovodja () {
			return settings.isRacunovodja(this.user.role);
		},
		isRoleModerator () {
			return settings.isModerator(this.user.role);
		},
		isRoleAdmin () {
			return settings.isAdmin(this.user.role);
		},
		razlika () {
			return ((this.prodajna_cena + this.povracila_skupaj) - this.znesek_racuna) - this.podaljsanoJamstvoZnesek - this.myrZnesek;
		},
		razlikaFormatted () {
			return this.moneyFormatter.format(this.razlika);
		},
		razlikaClass () {
			return {
				positive: this.razlika > 0,
				negative: this.razlika < 0,
				input_total: true
			};
		},
		isProdajalecPotrdil () {
			if (this.datumProdajalecPotrdil && this.datumProdajalecPotrdil !== '' && this.datumProdajalecPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isSekretarPotrdil () {
			if (this.datumSekretarPotrdil && this.datumSekretarPotrdil !== '' && this.datumSekretarPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isModeratorPotrdil () {
			if (this.datumModeratorPotrdil && this.datumModeratorPotrdil !== '' && this.datumModeratorPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isRacunovodjaPotrdil () {
			if (this.datumRacunovodjaPotrdil && this.datumRacunovodjaPotrdil !== '' && this.datumRacunovodjaPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		potrdiDisabled () {
			if (this.isRoleProdajalec) {
				if (!this.isProdajalecPotrdil && !this.isSekretarPotrdil && !this.isRacunovodjaPotrdil && !this.isModeratorPotrdil) {
					this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Prodajalec je že potrdil)';
					return true;
				}
			} else if (this.isRoleSekretar) {
				if (!this.isSekretarPotrdil && !this.isModeratorPotrdil && !this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Sekretar je že potrdil)';
					return true;
				}
			} else if (this.isRoleRacunovodja) {
				if (!this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else if (!this.isSekretarPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					} else {
						if (!this.isModeratorPotrdil) {
							this.gumbPotrdiTitle = 'Onemogočeno (Moderator še ni potrdil)';
							return true;
						}
						this.gumbPotrdiTitle = 'Potrdi kot računovodja';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Računovodja je že potrdil)';
					return true;
				}
			} else if (this.isRoleModerator) {
				if (!this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else if (!this.isSekretarPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					} else if (!this.isModeratorPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot moderator';
					} else {
						this.gumbPotrdiTitle = 'Potrdi kot računovodja';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Že potrjeno s strani računovodje)';
					return true;
				}
			} else if (this.isRoleAdmin) {
				if (!this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else if (!this.isSekretarPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					} else if (!this.isModeratorPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot moderator';
					} else {
						this.gumbPotrdiTitle = 'Potrdi kot računovodja';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Že potrjeno s strani računovodje)';
					return true;
				}
			}
			this.gumbPotrdiTitle = 'Onemogočeno (Neznana vloga uporabnika)';
			return true;
		},
		showUpdateFromMFilesButton () {
			if (this.isRoleSekretar || this.isRoleModerator || this.isRoleAdmin) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Plačilo" class="modal-primary" ok-title="Potrdi" cancel-title="Prekliči" @hidden="onHiddenModal" size="lg">
		<loading :active.sync="isLoading"></loading>
 		<b-row>
			<b-col>
				<b-form-group label="Prodajalec:">
					<b-form-input type="text" v-model="prodajalec" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group label="Kupec:">
					<b-form-input type="text" v-model="kupec" disabled></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-form-group label="Šasija:">
					<b-form-input type="text" v-model="ogrodje" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group label="Vozilo:">
					<b-form-input type="text" v-model="vozilo" disabled></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-form-group label="Št. računa (RNS):">
					<b-form-input type="text" v-model="st_racuna" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col v-if="showUpdateFromMFilesButton" class="cUpdate" cols="1">
				<b-button class="bUpdate" ref="aUpdate" data-style="zoom-in" size="sm" title="Pridobi podatke iz M-Files" @click.stop="click_updateData($event)">
					<i class="fa fa-file ladda-label"></i>
				</b-button>
			</b-col>
			<b-col cols="3">
				<b-form-group label="Datum računa (RNS):">
					<b-form-input type="text" :value="datum_racuna | hr_date" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col cols="3">
				<b-form-group label="Znesek računa (RNS):">
					<currency-input v-model="znesek_racuna" class="form-control input_significent" disabled />
				</b-form-group>
			</b-col>
		</b-row>
		<b-row class="r_povracila">
			<b-col class="l_znesek" cols="6">Prodajna cena:</b-col>
			<b-col cols="3"></b-col>
			<b-col cols="3"><currency-input v-model="prodajna_cena" class="form-control input_significent" disabled /></b-col>
		</b-row>
		<b-row v-for="nakazilo in nakazila" v-bind:key="'nakazilo-' + nakazilo.id" class="r_placilo r_povracila">
			<b-col class="l_znesek" cols="3">
				{{ nakazilo.tip }}
			</b-col>
			<b-col cols="3">
				<b-form-input type="text" :value="nakazilo.opomba" disabled></b-form-input>
			</b-col>
			<b-col cols="3">
				<b-form-input v-if="nakazilo.datum !== 'MM/DD/YYYY'" type="text" :value="nakazilo.datum | hr_date" disabled></b-form-input>
			</b-col>
			<b-col cols="3">
				<currency-input v-model="nakazilo.znesek" class="form-control" disabled />
			</b-col>
		</b-row>
		<b-row class="r_povracila">
			<b-col class="l_znesek" cols="6">Povračila (skupaj):</b-col>
			<b-col cols="3"></b-col>
			<b-col cols="3"><currency-input v-model="povracila_skupaj" class="form-control input_significent" disabled /></b-col>
		</b-row>
		<b-row class="mt-2">
			<b-col cols="6">Podaljsano jamstvo znesek:</b-col>
			<b-col cols="3"></b-col>
			<b-col cols="3"><currency-input v-model="podaljsanoJamstvoZnesek" class="form-control input_significent" disabled /></b-col>
		</b-row>
		<b-row class="mt-2">
			<b-col cols="6">Myr znesek:</b-col>
			<b-col cols="3"></b-col>
			<b-col cols="3"><currency-input v-model="myrZnesek" class="form-control input_significent" disabled /></b-col>
		</b-row>
		<b-row>
			<b-col cols="6"><h5 class="placila_sekcija">Razlika:</h5></b-col>
			<b-col cols="3"></b-col>
			<b-col class="l_izracun" cols="3">
				<b-form-input type="text" v-model="razlikaFormatted" disabled :class="razlikaClass"></b-form-input>
			</b-col>
		</b-row>
		<b-row style="margin-top:10px;">
			<b-col align-self="center">
				<b-form-group v-if="isProdajalecPotrdil" label="Prodajalec potrdil:">
					<b-form-input :value="datumProdajalecPotrdil | hr_date" type="text" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col align-self="center">
				<b-form-group v-if="isProdajalecPotrdil" label="Sekretar potrdil:">
					<b-form-input :value="datumSekretarPotrdil | hr_date" type="text" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col align-self="center">
				<b-form-group v-if="isProdajalecPotrdil" label="Moderator potrdil:">
					<b-form-input :value="datumModeratorPotrdil | hr_date" type="text" disabled></b-form-input>
				</b-form-group>
			</b-col>
			<b-col align-self="center">
				<b-form-group v-if="isProdajalecPotrdil" label="Računovodja potrdil:">
					<b-form-input :value="datumRacunovodjaPotrdil | hr_date" type="text" disabled></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-alert :variant="message.type && message.type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="start"></b-col>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click.stop="click_cancelModal($event)">Prekliči</b-button>
						<b-button variant="primary" @click.stop="click_okModal($event)" :title="gumbPotrdiTitle" :disabled="potrdiDisabled">Potrdi</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
.rb_TipProdaje {
	margin-top: 33px;
}
.b_akcija {
	margin-top: 27px;
}
.placila_sekcija {
	margin-top: 20px;
	margin-bottom: 20px;
}
.l_znesek {
	padding-top: 7px;
}
.l_izracun {
	padding-top: 13px;
}
.r_povracila {
	margin-top: 10px;
}
.r_razlika {
	margin-top: 10px;
}
.r_placilo {
	margin-bottom: 5px;
}
.positive {
	color: green;
}
.negative {
	color: red;
}
.input_significent {
	font-weight: bold;
}
.input_total {
	font-weight: bold;
}
.ma_pos {
	text-align: end;
}
.b_iconaction {
	padding: 0.375rem 0.50rem
}
.cUpdate {
	margin-top: 1.75rem;
	text-align: right;
}
.bUpdate {
	padding: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PlacilaModal.vue